import {
  AssetsService,
} from "@/common/api.service";
import {
  ASSET_DELETE,
  ASSET_EDIT,
  ASSET_UPLOAD,
  FETCH_ASSET,
  FETCH_ASSETS
} from "./actions.type";
import {
  SET_ASSET,
  SET_ASSETS
} from "./mutations.type";
import { displayNotification } from "@/common/notification";

const initialState = {
  progress: 0,
  asset: {},
  assets: []
};

export const state = { ...initialState };

export const actions = {
  async [FETCH_ASSET](context, assetId) {
    const { data } = await AssetsService.get(assetId);
    context.commit(SET_ASSET, data.asset);
    return data;
  },
  async [FETCH_ASSETS](context) {
    const { data } = await AssetsService.get();
    context.commit(SET_ASSETS, data);
    return data;
  },

  [ASSET_UPLOAD](context, asset) {
    return AssetsService.upload(asset)
      .then(res => {
        displayNotification("Upload successful", "success");
        return true;
      })
      .catch(err => {
        displayNotification("Upload failed - " + err.response.data.errors.message, "warning");
        return false;
      });
  },

  [ASSET_EDIT](context, asset) {
    return AssetsService.update(asset._id, asset);
  },

  [ASSET_DELETE](context, asset) {
    return AssetsService.delete(asset._id);
  },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [SET_ASSET](state, asset) {
    state.asset = asset;
  },
  [SET_ASSETS](state, assets) {
    state.assets = assets;
  },
};

const getters = {
  asset(state) {
    return state.asset;
  },
  assets(state) {
    return state.assets;
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};
